import React from 'react';
import PropTypes from 'prop-types';

import SharesRow from './shares_row';
import './styles/main.scss';

class SharesManagement extends React.Component {
  state = {
    queryString: null,
    visibleShares: this.props.shares
  }

  updateSearch = (event) => {
    this.setState({ queryString: event.target.value });
  }

  deleteShareManifest = (shareKey) => {
    $.ajax({
      type: 'DELETE',
      url: `/api/v4/share_manifests/${shareKey}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      context: this,
      success: () => {
        this.setState((prevState) => (
          { visibleShares: prevState.visibleShares.filter((share) => share.key !== shareKey) }
        ));
      }
    });
  }

  formatDate = (railsDate) => {
    const jsDate = new Date(railsDate);
    return railsDate
      ? `${jsDate.getMonth() + 1}/${jsDate.getDate()}/${jsDate.getFullYear().toString().substr(-2)}`
      : null;
  }

  sharesToShow() {
    const { visibleShares, queryString } = this.state;
    return (queryString && queryString.length > 0) ? this.queriedShares() : visibleShares;
  }


  queriedShares() {
    const { visibleShares, queryString } = this.state;
    return visibleShares.filter((share) => {
      const filterableString = `${share.name} ${share.created_by}
      ${this.formatDate(share.availability_end)} ${this.formatDate(share.created_at)}`.toLowerCase();
      return filterableString.includes(queryString.toLowerCase());
    });
  }

  renderSortingOptions() {
    return (
      <input
        id="share-link-search"
        className="searchbar"
        type="text"
        placeholder={`Search ${this.props.shares.length} share links`}
        onChange={this.updateSearch}
      />
    );
  }

  renderNoShareLinks() {
    return (
      <div className="manage-shares">
        {`${BF.fx.brandfolder().name} does not have any share links.`}
      </div>
    );
  }

  render() {
    if (!this.props.shares || this.props.shares.length < 1) {
      return this.renderNoShareLinks();
    }
    return (
      <div className="manage-shares">
        <h2>Manage Share Links for {BF.fx.brandfolder().name}</h2>
        <hr />
        {this.renderSortingOptions()}
        <div className="headers">
          <h3 className="thirty">Name</h3>
          <h3 className="fifteen">Created by</h3>
          <h3 className="ten center"># Assets</h3>
          <h3 className="ten center">Access</h3>
          <h3 className="seven center">Created</h3>
          <h3 className="eight center">Expiration</h3>
          <h3 className="five center">Id</h3>
          <div className="five center" />
          <div className="five center" />
        </div>
        { this.sharesToShow().map((share) => (
          <div className="share-row" key={share.key}>
            <SharesRow
              share={share}
              deleteShareManifest={this.deleteShareManifest}
              formatDate={this.formatDate}
              assetCount={this.props.shareCountMap[share.shareable_id]}
            />
          </div>
        ))
        }
      </div>
    );
  }
}

SharesManagement.propTypes = {
  shares: PropTypes.arrayOf(PropTypes.object).isRequired,
  shareCountMap: PropTypes.shape({
    id: PropTypes.number
  }).isRequired
};

export default SharesManagement;
